import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { environment } from '@base/environments/environment';
import {
  ListUsersLoggedUser,
  LogedUser,
} from '../../models/logged-user.model';
import { LoggedUserService } from '../../../services/logged-user.service';
import { ChangeUserOldFEService } from '../../../services/panel/change-user-old-fe.service';
import { UserSessionService } from '../../../services/user-session.service';
import { AuthSession } from '../auth-session';

@Injectable()
export class LegacyAuthSessionService implements AuthSession {
  constructor(
    private readonly loggedUserService: LoggedUserService,
    private readonly changeUserOldFEService: ChangeUserOldFEService,
    private readonly userSessionService: UserSessionService,
    @Inject(DOCUMENT) private readonly document: Document,
  ) {}

  async restoreSession(): Promise<LogedUser> {
    const RESPONSE = await this.loggedUserService.get();
    if (!RESPONSE) {
      throw new Error('No active session');
    }
    this.userSessionService.loggedUser = RESPONSE;
    return RESPONSE;
  }

  async switchOffice(user: ListUsersLoggedUser): Promise<void> {
    const RESPONSE = await this.changeUserOldFEService.get(user.user.toString());
    if (!RESPONSE?.result) {
      throw new Error('Office switch failed');
    }
  }

  logout(): void {
    this.document.location.href = environment.oldFrontUrl + '/logout';
  }
}
